module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('q-card', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "inline": ""
    }
  }, [_c('q-card-media', [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _c('q-card-title', [_c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_c('u', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('q-card-separator'), _vm._v(" "), _c('q-card-main', [_c('h5', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.content) + ":")]), _vm._v(" "), _c('h4', {
    attrs: {
      "align": "center"
    }
  }, [_c('br'), _vm._v(_vm._s(_vm.price))])]), _vm._v(" "), _c('q-card-actions', [_c('q-btn', {
    staticStyle: {
      "width": "100%",
      "background": "rgba(0,0,0,0.1)"
    },
    attrs: {
      "flat": ""
    }
  }, [_c('h5', [_vm._v("Sign up now!")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79ca18ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceEntry.vue
// module id = 22
// module chunks = 0